export default __webpack_public_path__ + "static/media/home-hero-bf-2.6497c0e7.png";